import React, { useEffect, useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import { Authentication } from "@swegon/sds-core";
import { config } from "../Sds/config";
import { getAhuBaseUrl } from "../ahu/lib";

// Without a stored return URL, go to the latest version at /ahu/, not to the
// version this build is stamped with (SDS_APP_AHU)
export const getRedirectUrl = () => {
    const after_redirect = localStorage.getItem("after_redirect");
    return Authentication.isSafeRedirect(after_redirect)
        ? after_redirect
        : getAhuBaseUrl("/", config);
};

export const SignedOn = () => {
    const { signedOn, isAuthenticated } = useContext(Authentication.AuthContext);
    const location = useLocation();

    // Read once on mount: isAuthenticated() consumes "after_redirect", so a
    // later render would otherwise fall back to /ahu/
    const [redirectUrl] = useState(getRedirectUrl);
    const authenticated = isAuthenticated();

    useEffect(() => {
        signedOn(location.hash);
    }, [signedOn, location.hash]);

    useEffect(() => {
        // Both values are document URLs (often absolute, on another app version),
        // not router paths. <Navigate> would append them to /authorized
        if (authenticated) {
            window.location.replace(redirectUrl);
        }
    }, [authenticated, redirectUrl]);

    return <div>Signing on...</div>;
};

export default SignedOn;
